<!--
  结算模块
-->
<template>
  <div class="settle-container light-bg" ref="settleContain">
    <!--头部-->
    <div class='title-header'>订单支付</div>
    <van-loading class="data-loading" color="#45C5DA" v-show="showLoading" />
  </div>
</template>

<script>
import api from 'api/user';
import { getWxSign } from 'common/js/getSDKSign';
import wx from 'weixin-js-sdk';
import { Toast } from 'vant';
import axios from 'axios';
import { settleParamsList } from 'common/js/settleParams';
export default {
  data() {
    return {
      showLoading: false,
      token: '',
      orderSn: '',
      orderId: ''
    };
  },
  async created() {
    this.showLoading = true;
    this.token = this.$route.query.token;
    this.orderSn = this.$route.query.orderSn;
    this.orderId = this.$route.query.orderId;
    this.paramsObj = settleParamsList.filter(item => item.type == this.$route.query.type)[0];
    window.document.title=this.paramsObj.title;
    //微信签名
    //上选的签名接口
    if(this.paramsObj.type == '1') {
      await getWxSign(this.submitOrder)
    }
    //云集的签名接口
    else if (this.paramsObj.type == '2'){
      await this.getWxSign2(this.submitOrder)
    }
  },
  mounted(){
  },
  methods: {
    //发起支付
    async submitOrder() {
      console.log(1)
      let data, sign;
      if (this.$route.query.type == '2') {
        data = await this.postJsonApi().catch(res => console.log(res))
        sign = data.data;
      }else{
        data = await this.getApi().catch(res => console.log(res))
        sign = data.data;
      }
      let that = this;
      this.showLoading = false;
      console.log(data)
      wx.chooseWXPay({
        timestamp: sign.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: sign.nonceStr, // 支付签名随机串，不长于 32 位
        package: sign.package || sign.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: sign.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: sign.paySign, // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          console.log(res);
          window.location.href = that.paramsObj.successUrl;
        },
        cancel: function (res) {
          console.log(res);
          window.location.href = that.paramsObj.failUrl;
        }
      });
    },
    async getApi() {
      let _this = this;
      let res = await axios.get(_this.paramsObj.api, {
        params:{orderSn : _this.orderSn},
        headers: {
          ticket: _this.token,
        },
      });
      return res.data || {};
    },
    async postJsonApi() {
      let params = {  
        orderId : Number(this.orderId),
        tradeType:"JSAPI" ,//微信支付
      }
      let _this = this;
      let res = await axios.post(this.paramsObj.api, params,
        {
        headers: {
          'Content-Type': 'application/json',
          ticket: _this.token,
        },
      });
      return res.data || {};
    },
    //云集jssdk接口
    async getWxSign2(cb) {
      let params = {  
        url: window.location.href
      }
      let _this = this;
      let res = await axios.post(this.paramsObj.jssdkApi, params,
        {
        headers: {
          'Content-Type': 'application/json',
          ticket: _this.token,
        },
      });
      const data = res.data.data;
      wx.config({
        debug: false, // 开启调
        // 试模式,
        appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature,// 必填，签名，见附录1
        jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','chooseWXPay','openAddress'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      cb && wx.ready(cb)
    },
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.title-header{
  display: flex;
  height: 45px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #ddd;
  background: #fff;
}

</style>
